import axios from "axios";
import Config from "../config";

const updateMessage = data => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/message/update",
        data
    });
};

export default updateMessage;
